<template>
    <div>
        <div v-for="option in filter.inputs.mode.options" :key="option.value">
            <div class="form-group form-group-32">
                <label :for="'opt' + option.value" class="form-label label-auto">
                    <input
                        :id="'opt' + option.value"
                        v-model="mode"
                        type="radio"
                        :value="option.value"
                    />
                    {{ option.label }}
                </label>
            </div>

            <div v-if="mode === option.value">
                <div class="form-group form-group-32">
                    <div v-if="mode === 'between'" class="form-input block">
                        <input
                            v-model="min"
                            type="number"
                            required
                            class="wp-10"
                            :placeholder="$t.__('listing.filters.RangeFilter.min_value')"
                            step="any"
                        />
                    </div>
                    <div
                        v-if="mode !== 'known' && mode !== 'unknown' && mode !== 'between'"
                        class="form-input block"
                    >
                        <input v-model="min" type="number" required class="wp-10" step="any" />
                    </div>
                </div>

                <div v-if="mode === 'between'" class="form-group form-group-32">
                    <div class="form-input block">
                        <input
                            v-model="max"
                            type="number"
                            required
                            class="wp-10"
                            :placeholder="$t.__('listing.filters.RangeFilter.max_value')"
                            step="any"
                        />
                    </div>
                </div>

                <div v-if="filter.inputs.unit !== undefined" class="form-group form-group-32">
                    <label class="form-label">
                        {{ $l10n.__('Unité') }}
                    </label>
                    <div class="form-input block">
                        <select v-model="unit">
                            <option
                                v-for="opt in filter.inputs.unit.options"
                                :key="opt.value"
                                class="wp-10"
                                :value="opt.value"
                                v-text="opt.label"
                            />
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],
    data() {
        return {
            mode: '',
            min: '',
            max: '',
            unit: '',
        };
    },
    computed: {
        label() {
            return this.filter.inputs.mode.options[this.mode].label;
        },
        data() {
            return {
                mode: this.mode,
                min: this.min,
                max: this.max,
                unit: this.unit,
            };
        },
    },
};
</script>
